__turbopack_context__.v({
  "actionBtn": "tFD6Aa_actionBtn",
  "closeOnlyDialog": "tFD6Aa_closeOnlyDialog",
  "dialog": "tFD6Aa_dialog",
  "message": "tFD6Aa_message",
  "normalDialog": "tFD6Aa_normalDialog",
  "registBtn": "tFD6Aa_registBtn",
  "resetBtn": "tFD6Aa_resetBtn",
});
